@use '@/styles/tokens' as *;

.layout {
  display: flex;
  min-height: 100vh;
}

.brand {
  flex: 0 0 58.333%; // 14/24 split on desktop, mirrors the prior Col span
  position: relative;
  // Matches the storefront's own hero image (`object-position: 0% 50%`) — anchors the photo's
  // left edge and vertical centre, which is what the decorative overlay's coordinates assume.
  background-size: cover;
  background-position: 0% 50%;
  padding: 48px 62px 128px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  // Brand panel is desktop-only; below lg the form panel takes the full width.
  @include down(lg) {
    display: none;
  }
}

.logo {
  width: 72px;
  height: auto;
}

// 110180: the field-boundary overlay — outline, 4 corner dots, 2 dashed arcs to the soil pill,
// 2 faint outline shapes, 2 leader stems, and the 3 chips (as `foreignObject`s). One inline SVG,
// `viewBox="0 0 1440 813"` + `preserveAspectRatio="xMinYMid slice"` — same slice/cover anchor as
// `.brand`'s own `background-position: 0% 50%`, so this layer and the photo scale identically at
// any viewport instead of drifting apart (the bug a panel-relative % layer had).
.heroDecor {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.decorFaint path {
  fill: none;
  stroke: #fff;
  stroke-width: 1.5px;
}

.decorPlot {
  fill: none;
  stroke: #fff;
  stroke-width: 2.3px;
}

.decorConnector {
  stroke: #fff;
  stroke-width: 1.5px;
  opacity: 0.6;
}

.decorDot circle {
  fill: #f1ff58;
}

// Values pulled from the storefront's live, computed styles (the correct reference) — the
// original admin build (110180) approximated these instead of matching the design exactly.
.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border: 1px solid rgb(255 255 255 / 40%);
  border-radius: 9999px;
  backdrop-filter: blur(12px);
  background: rgb(0 0 0 / 60%);
  color: #fff;
  font-size: 15px;
  line-height: 1.5;
  white-space: nowrap;
}

.chip img {
  width: 22px;
  height: 22px;
}

.chipSoil {
  align-items: flex-start;
  background: $color-accent1-500;
  color: $color-brand-900;
}

.chipSoil img {
  width: 28px;
  height: 28px;
}

.chipReading {
  display: flex;
  flex-direction: column;
}

.chipReading strong {
  font-size: 20px;
  font-weight: $font-weight-medium;
}

.chipReading small {
  font-size: 11px;
  font-weight: $font-weight-regular;
}

.tagline {
  display: flex;
  flex-direction: column;
  gap: $space-3;
}

.tagline h2 {
  font-size: 44px;
  line-height: 1.2;
  color: $color-accent1-500;
  max-width: 393px;
  font-family: $font-family-heading;
  font-weight: 300;
  letter-spacing: -2%;
  margin: 0;
}

.tagline p {
  color: $color-brand-50;
  font-size: $font-size-xl;
  margin: 0;
}

.panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
}

.outlet {
  flex: 1;
  display: grid;
  place-items: center;
  width: 100%;
  position: relative;
}

.card {
  width: 100%;
  max-width: 400px;
  animation: rise 320ms ease both;
}

.cardHeader {
  margin-bottom: 24px;
  text-align: center;
}

.cardHeader h1 {
  font-size: 32px;
  font-family: $font-family-heading;
  font-weight: $font-weight-regular;
  margin: 0 0 8px;
}

.cardHeader p {
  color: $color-neutral-800;
  margin: 0;
  font-size: $font-size-xs;
}

.bgPattern {
  position: absolute;
  top: -5%;
  left: 5%;
  object-fit: cover;
  opacity: 0.5;
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .card {
    animation: none;
  }
}
